const ResetPasswordForm = ({ onReset, email, loading, error }) => (
  <form className="login-form" onSubmit={onReset}>
    {error && <div className="error-message">{error}</div>}
    <div className="input-group">
      <label htmlFor="code">Verification Code</label>
      <input type="text" id="code" name="code" required placeholder="Enter the code from email" />
    </div>
    <div className="input-group">
      <label htmlFor="newPassword">New Password</label>
      <input type="password" id="newPassword" name="newPassword" required />
    </div>
    <button type="submit" className="login-btn" disabled={loading}>
      {loading ? 'Resetting...' : 'Reset Password'}
    </button>
  </form>
);

export default ResetPasswordForm;
